import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../services";
import { resetUserStore, setUserDetails } from "../store";
import { API_SUCCESS_CODES } from "../constants";

export function useSyncUser(dispatch) {
  const navigate = useNavigate();
  const { user, order } = useSelector((state) => ({
    user: state.user,
    order: state.order
  }));

  return useQuery({
    queryKey: ["sync-user", user.authToken],
    queryFn: async () => {
      if (!user.authToken) {
        throw new Error("User not logged in");
      }

      const response = await ApiService.post(
        "me/sync",
        { ...user.shopifyDetails, shop: order.shopDomain },
        {
          authorization: `Bearer ${user.authToken}`
        }
      );

      if (!API_SUCCESS_CODES.includes(response.statusCode)) {
        dispatch(resetUserStore());
        return navigate("/login");
      }

      dispatch(setUserDetails(response.data.user));
      return response.data.user;
    },
    staleTime: Infinity,
    enabled: !!user.authToken
  });
}

export function useGetUserDetail(user, dispatch) {
  return useQuery({
    queryKey: ["me-user", user.authToken],
    queryFn: async () => {
      if (!user.authToken) throw new Error("User not logged in");

      const response = await ApiService.get("me", {
        authorization: `Bearer ${user.authToken}`
      });

      dispatch(setUserDetails(response));
      return response;
    },
    staleTime: Infinity,
    enabled: !!user.authToken
  });
}
